import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  rootBorder: {
    borderLeft: `1px solid ${theme.palette.text.hint}`
  },
  appPageHeader: {
    height: "auto"
  },
  appPageContentContainer: {
    maxHeight: "calc(100dvh - 124px)",
    overflowY: "auto",
    display: "flex",
    flex: "auto",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100dvh - 164px)"
    }
  },
  mapHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: 60,
    boxShadow: "5px 1px 7px 0px #00000026",
    zIndex: 1,
    paddingLeft: 24,
    paddingRight: 8,
    borderBottom: `1px solid ${theme.palette.primary.light}`,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 42
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 8
    }
  },
  mapHeaderTitle: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  mapFacilitySelectWrapper: {
    flex: "auto",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "left",
      maxWidth: "calc(100% - 30px)"
    }
  },
  progress: {
    textAlign: "center"
  },
  appPageHeaderTabs: {
    marginBottom: 0,
    position: "static",
    "& .MuiTab-wrapper:after": {
      top: -1,
      right: 3
    }
  },
  "grid-container": {
    display: "grid",
    width: "100%",
    padding: 24,
    gridTemplateColumns: "repeat(12, 1fr)",
    gap: "20px 20px",
    gridTemplateRows: "156px minmax(min-content, max-content) 1fr",
    gridTemplateAreas: `
        "grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-info grid-info grid-info grid-right-rail grid-right-rail grid-right-rail grid-right-rail"
        "grid-activity grid-activity grid-activity grid-activity grid-activity grid-info grid-info grid-info grid-right-rail grid-right-rail grid-right-rail grid-right-rail"
        "grid-activity grid-activity grid-activity grid-activity grid-activity grid-info grid-info grid-info grid-right-rail grid-right-rail grid-right-rail grid-right-rail"`
  },

  "grid-details-and-days": {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridTemplateRows: "min-content",
    gap: "20px 20px",
    gridTemplateAreas: `"grid-info-panels grid-info-panels grid-info-panels grid-info-panels grid-info-panels grid-info-panels grid-info-panels grid-info-panels grid-info-panels grid-days-off grid-days-off grid-days-off"`,
    gridArea: "grid-details-and-days"
  },
  "grid-info-panels": {
    gridArea: "grid-info-panels"
  },
  "grid-days-off": {
    gridArea: "grid-days-off"
  },
  "grid-activity": {
    gridArea: "grid-activity"
  },
  "grid-information": { gridArea: "grid-information" },
  "grid-location": { gridArea: "grid-location" },
  "grid-info": {
    display: "grid",
    gap: "20px 20px",
    gridTemplateColumns: "minmax(0, 1fr)",
    gridTemplateRows: "min-content",
    gridTemplateAreas: `
        "grid-information"
        "grid-location"`,
    gridArea: "grid-info"
  },

  "grid-right-rail": {
    display: "grid",
    gridTemplateColumns: "auto",
    gridTemplateRows: "min-content min-content min-content",
    gap: "20px 20px",
    gridTemplateAreas: `
        "grid-preferred-condition"
        "grid-upcoming-events"
        "grid-comments"`,
    gridArea: "grid-right-rail"
  },
  "grid-preferred-condition": { gridArea: "grid-preferred-condition" },
  "grid-upcoming-events": {
    gridArea: "grid-upcoming-events",
    [theme.breakpoints.down("sm")]: {
      minHeight: "unset"
    }
  },
  "grid-comments": { gridArea: "grid-comments" },
  tabs: {
    display: "none"
  },
  noComments: {
    "grid-info": {
      display: "grid",
      gridTemplateColumns: "",
      gridTemplateRows: "max-content max-content",
      gap: "20px 20px",
      gridArea: "grid-info",
      gridTemplateAreas: `
          "grid-information" .
          "grid-location" "grid-location"`
    },
    "& $grid-container": {
      gridTemplateAreas: `
        "grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-info grid-info grid-info grid-right-rail grid-right-rail grid-right-rail grid-right-rail"
        "grid-activity grid-activity grid-activity grid-activity grid-activity grid-info grid-info grid-info grid-right-rail grid-right-rail grid-right-rail grid-right-rail"
        "grid-activity grid-activity grid-activity grid-activity grid-activity grid-info grid-info grid-info"`
    },
    "& $grid-right-rail": {
      gridTemplateRows: "min-content auto ",
      gap: "20px 20px",
      gridTemplateAreas: `
          "grid-preferred-condition"
          "grid-upcoming-events"
          "grid-location"`
    },
    "& $grid-comments": {
      display: "none"
    },
    "& $grid-info": {}
  },

  // screenWidth < 1920px
  [theme.breakpoints.down("lg")]: {
    "grid-container": {
      gridTemplateAreas: `
        "grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-details-and-days grid-right-rail grid-right-rail grid-right-rail grid-right-rail"
        "grid-activity grid-activity grid-activity grid-activity grid-activity grid-activity grid-activity grid-activity grid-right-rail grid-right-rail grid-right-rail grid-right-rail"
        "grid-info grid-info grid-info grid-info grid-info grid-info grid-info grid-info grid-right-rail grid-right-rail grid-right-rail grid-right-rail"`
    },
    "grid-info": {
      display: "grid",
      gap: "20px 20px",
      gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
      gridTemplateRows: "min-content",
      gridTemplateAreas: `
          "grid-information grid-location"`,

      gridArea: "grid-info"
    }
  },
  // screenWidth < 1280px
  [theme.breakpoints.down("md")]: {
    header: {
      height: "70px"
    }
  },
  // screenWidth < 960px
  [theme.breakpoints.down("sm")]: {
    tabs: {
      display: "block"
    },
    details: {
      "& $grid-container": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-details-and-days" "grid-right-rail" "grid-info"`
      },
      "& $grid-details-and-days": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-info-panels"`
      },
      "& $grid-right-rail": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-preferred-condition"`
      },
      "& $grid-info": {
        gridTemplateColumns: "minmax(0, 1fr)",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-location" "grid-information"`
      },
      [`& $activity`]: {
        display: "none"
      },
      [`& $details`]: {},
      [`& $comments`]: {
        display: "none"
      }
    },
    activity: {
      "& $grid-container": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-details-and-days" "grid-right-rail" "grid-activity" "grid-info"`
      },
      "& $grid-details-and-days": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-days-off"`
      },
      "& $grid-right-rail": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-upcoming-events"`
      },
      [`& $activity`]: {},
      [`& $details`]: {
        display: "none"
      },
      [`& $comments`]: {
        display: "none"
      }
    },
    comments: {
      "& $grid-container": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto min-content min-content min-content",
        gridTemplateAreas: `"grid-right-rail" "grid-details-and-days" "grid-activity" "grid-info"`,
        height: "100%"
      },
      "& $grid-right-rail": {
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto",
        gridTemplateAreas: `"grid-comments"`
      },
      "& $grid-comments": {
        display: "block"
      },
      [`& $activity`]: {
        display: "none"
      },
      [`& $details`]: {
        display: "none"
      },
      [`& $comments`]: {}
    }
  },
  // screenWidth < 600px
  [theme.breakpoints.down("xs")]: {},
  noBorder: {
    border: "none"
  }
}));
